import { useMutation } from "@tanstack/react-query";
import apiV2 from "api-v2";
import type { TotpSetupResource } from "../types/Mfa.type";

export interface TotpSetupPayload {
	password: string;
}

const startTotpSetup = async (payload: TotpSetupPayload): Promise<TotpSetupResource> => {
	const response = await apiV2.post("/mfa/totp/setup", payload);
	return (response.data as { data?: TotpSetupResource })?.data ?? response.data;
};

export const useTotpSetup = () =>
	useMutation<TotpSetupResource, Error, TotpSetupPayload>({
		mutationFn: startTotpSetup,
	});
